import React, { useId } from 'react';

//? Nome da assistente de IA na tela (spec ai-assistant-06)
export const TALIA = 'Talia';

interface TaliaAvatarProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  //? Pontinho verde de "online" (cabeçalho da janela)
  online?: boolean;
  className?: string;
}

//* Marca da Talia: "T" com brilho sobre o degradê azul → verde-azulado do sistema
const TaliaAvatar: React.FC<TaliaAvatarProps> = ({ size = 'md', online = false, className = '' }) => {
  const gradientId = `talia-${useId().replace(/:/g, '')}`;
  return (
    <span className={`talia-avatar talia-avatar-${size} ${className}`} aria-hidden="true">
      <svg viewBox="0 0 40 40" width="100%" height="100%">
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0071b6" />
            <stop offset="100%" stopColor="#02a8b5" />
          </linearGradient>
        </defs>
        <circle cx="20" cy="20" r="20" fill={`url(#${gradientId})`} />
        <path d="M11.5 13.5h15M19 13.5v15" stroke="#fff" strokeWidth="3.6" strokeLinecap="round" fill="none" />
        <path
          d="M29.5 8.5c.35 1.9 1.1 2.65 3 3-1.9.35-2.65 1.1-3 3-.35-1.9-1.1-2.65-3-3 1.9-.35 2.65-1.1 3-3z"
          fill="#fff"
          opacity="0.95"
        />
      </svg>
      {online && <span className="talia-online" />}
    </span>
  );
};

export default TaliaAvatar;
